import * as React from 'react';
import PropTypes from 'prop-types';
import { Button, Text } from '@kui/foundations-react';
import ProductInfo from '../presentational/ProductFamilyInfo/ProductInfo';
import '../../styles/RegCard.css';
import '../../styles/ConfirmationCard.css';

// Product-family confirmation shown before the form / sign-in. Same props and behaviour as the old
// dialog: Agree dismisses it, Cancel calls handleCancelClickEvent. Rendered as a card on a plain page
// (Figma card style) that covers the page until the user answers, like the modal it replaces.
export default function ConfirmationDialog(props) {
  const [open, setOpen] = React.useState(true);
  const cardRef = React.useRef(null);
  const titleId = 'confirmationCardTitle';
  const hasTitle = props.title !== undefined && props.title !== '';

  React.useEffect(() => {
    if (open && cardRef.current) {
      cardRef.current.focus();
    }
  }, [open]);

  if (!open) {
    return null;
  }

  return (
    <div className="confirmCardPage">
      <div
        className="regCard confirmCard"
        role="dialog"
        aria-modal="true"
        aria-labelledby={hasTitle ? titleId : undefined}
        tabIndex={-1}
        ref={cardRef}
      >
        {hasTitle && (
          <Text kind="title/md" asChild>
            <h1 id={titleId} className="regHeaderTitle">
              {props.title}
            </h1>
          </Text>
        )}
        <div className="confirmCardBody">
          <ProductInfo
            BoxxProductFamily={props.BoxxProductFamily}
            PartnerURLVal={props.PartnerURLVal}
            link={props.link}
            linktext={props.linktext}
            idmlogin={props.idmlogin}
            isrwa03={props.isrwa03}
            isrwa04={props.isrwa04}
            title={props.title}
            productfamily={props.productfamily}
            licensetype={props.licensetype}
          />
        </div>
        <div className="confirmCardActions">
          <Button kind="secondary" color="neutral" onClick={props.handleCancelClickEvent}>
            Cancel
          </Button>
          <Button kind="primary" color="brand" onClick={() => setOpen(false)}>
            Agree
          </Button>
        </div>
      </div>
    </div>
  );
}

ConfirmationDialog.propTypes = {
  handleCancelClickEvent: PropTypes.func.isRequired,
  BoxxProductFamily: PropTypes.string.isRequired,
  PartnerURLVal: PropTypes.string.isRequired,
  productfamily: PropTypes.string.isRequired,
  licensetype: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  isrwa03: PropTypes.number.isRequired,
  isrwa04: PropTypes.number.isRequired,
  idmlogin: PropTypes.string.isRequired,
  linktext: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
};
